/**
 * Changes tabs to accordions on the WooCommerce product page.
 */
(() => {
    let containers = document.querySelectorAll('.woocommerce-tabs');

    if (!containers.length) {
        return;
    }

    /**
     * Whether or not to have the first accordion item open on page load.
     */
    const firstOpen = false;

    containers.forEach((container) => {
        let panels = document.querySelectorAll('.woocommerce-tabs .panel');

        let isFirst = firstOpen;

        if (!panels.length) {
            return;
        }

        panels.forEach((panel) => {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');

            let button = document.createElement('button');
            button.classList.add('woocommerce__tab_to_accordion__button');
            button.classList.add('js-accordion-button');

            let wrapper = document.createElement('div');
            wrapper.classList.add('woocommerce__tab_to_accordion__container');

            let h = panel.querySelector('h2');
            if (h) {
                button.append(h);
            }

            if (isFirst) {
                isFirst = false;
                button.setAttribute('aria-expanded', 'true');
            } else {
                button.setAttribute('aria-expanded', 'false');
            }

            panel.parentNode.insertBefore(button, panel);
            panel.parentNode.insertBefore(wrapper, panel);
            wrapper.append(panel);
        });

        window.accordion_tools.enableAccordions(container);
    });
})();
